import { render, staticRenderFns } from "./MspForsageOrdersItemName.vue?vue&type=template&id=9c6f707a&scoped=true&"
import script from "./MspForsageOrdersItemName.vue?vue&type=script&lang=js&"
export * from "./MspForsageOrdersItemName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6f707a",
  null
  
)

export default component.exports